// (C) Copyright 2020 MediaWink, LLC

export const UNSPLASH_SAGA = 'UNSPLASH_SAGA';
